import { useState, useContext } from 'react';
import { Award } from 'lucide-react';
import AuthContext from '../../../../../../../context/AuthContext';
import { useToast } from '../../../../../../../context/ToastContext';
import ConfirmationModal from '../../../../../../../components/ConfirmationModal';
import auditPlanService from '../../../../../../../services/audit_services/auditPlanService';

export default function AchieveModal({ isOpen, onClose, planId, onSuccess }) {
  const { authTokens } = useContext(AuthContext);
  const { showError, showSuccess } = useToast();
  const [loading, setLoading] = useState(false);

  const handleAchieve = async () => {
    setLoading(true);
    
    try {
      const result = await auditPlanService.achieveAuditPlan(authTokens.access, planId);
      
      if (result.success) {
        showSuccess('Plan d\'audit archivé avec succès');
        onSuccess();
        onClose();
      } else {
        showError(result.error || 'Erreur lors de l\'archivage du plan d\'audit');
      }
      setLoading(false);
    } catch (error) {
      console.error('Error achieving audit plan:', error);
      showError('Erreur lors de l\'archivage du plan d\'audit');
      setLoading(false);
    }
  };

  return (
    <ConfirmationModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={handleAchieve}
      title="Archiver le plan d'audit"
      message="Êtes-vous sûr de vouloir marquer ce plan d'audit comme archivé ? Cela indique la réalisation réussie de tous les objectifs d'audit."
      confirmText={loading ? 'Archivage...' : 'Archiver'}
      confirmButtonClass="bg-green-600 hover:bg-green-700"
      icon={<Award className="h-6 w-6 text-green-600" />}
      loading={loading}
    />
  );
}
